import {produce} from 'immer'

import React, {useEffect, useState} from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../../../../../../hooks/react-redux'
import {useJobId} from '../../../../../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {
  getDraftJobs,
  isSuggestionSkipped,
  getSkippedSuggestions,
} from '../../../../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {
  pipelineDraft,
  suggestions,
} from '../../../../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../../../../hooks/pipeline'
import {StepTypes} from '../../../../../../../../../types'
import SuggestionMessage from '../../../../../../../SuggestionMessage/SuggestionMessage'
import {WORKING_DIRECTORY} from '../../JobStep.consts'
import type {SmartDetectorProps} from '../SmartDetectors.types'

export function CdToWorkingDir({
  name,
  value,
  stepIndex,
  focused,
  anchorElement,
}: SmartDetectorProps) {
  const jobId = useJobId()!
  const id = usePipelineId()
  const stepId = `step-${jobId}-${stepIndex + 1}`
  const stepList = useAppSelector(state => getDraftJobs(state, id)?.[jobId]?.steps)
  const skippedSuggestionList = useAppSelector(state => getSkippedSuggestions(state, stepId))
  const isSkipped = useAppSelector(state => isSuggestionSkipped(state, stepId, WORKING_DIRECTORY))

  const currentStep = stepList?.[stepIndex]
  const dispatch = useAppDispatch()

  const match = value.match(/^cd ([\w\/]+)(?: && (.*)|\n([\s\S]*))$/)
  const [_, directory, inlineScript, script] = match ?? []
  const visible = !currentStep?.[WORKING_DIRECTORY] && !isSkipped && !!match && focused

  const [workingDirectory, setWorkingDirectory] = useState('')
  useEffect(() => {
    setWorkingDirectory(prevState => directory ?? prevState)
  }, [directory])

  return (
    <SuggestionMessage
      message={`We detected cd command. Set ${workingDirectory} as the working directory for this script instead? This will help us optimize your pipeline`}
      actionText="Set"
      visible={visible}
      onCancelClick={() => {
        dispatch(
          suggestions.actions.skip({
            id: stepId,
            values: produce(skippedSuggestionList ?? [], draft => {
              if (!draft.includes(WORKING_DIRECTORY)) {
                draft.push(WORKING_DIRECTORY)
              }
            }),
          }),
        )
      }}
      onActionClick={() => {
        dispatch(suggestions.actions.showSuccessMessage({id: stepId, type: StepTypes.CLI}))
        dispatch(
          pipelineDraft.actions.setSteps({
            id,
            jobId,
            steps: produce(stepList ?? [], draft => {
              const step = draft[stepIndex]
              step[WORKING_DIRECTORY] = directory
              step[name] = inlineScript || script
            }),
          }),
        )
        anchorElement?.focus()
      }}
    />
  )
}
